import styled from 'styled-components'
import tw from 'twin.macro'

export const Container = styled.div`
  ${tw`flex items-center bg-white border-DEFAULT border-solid border-blueGray300 w-full py-3 pl-112px`};
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);

  ${(props) => props.css}
`
